<template>
  <div>
    <v-simple-table>
      <template #default>
        <thead :class="`table-heading`">
          <tr>
            <th
              v-for="(header, index) in headers"
              :key="index"
              class="text-center text-dark"
            >
              <b class="pre-line">{{ header.title }}</b>
            </th>
          </tr>
        </thead>
        <tbody :class="`${colorClass}`">
          <tr v-if="!loading">
            <td>
              <b> {{ user.channels[chnl] | capitalizeFirstLetter }}</b>
            </td>
            <td>{{ formatNumber(data.CSEMANT, '$', 0) }}</td>
            <td>{{ formatFloat(data.PCSEMANT, 2) }}%</td>
            <td>{{ formatNumber(data.PBSEM12, '$', 0) }}</td>
            <td>{{ formatNumber(data.FBPNC, '$', 0) }}</td>
            <td>{{ formatNumber(data.PSEMPNC, '$', 0) }}</td>
            <td>{{ formatFloat(data.PBSEM3, 2) }}%</td>
            <td>{{ formatFloat(data.PCREC, 2) }}%</td>
          </tr>
          <tr v-else>
            <td colspan="8">
              <v-skeleton-loader type="text" />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-alert
      v-if="error"
      class="w-50"
      dense
      outlined
      type="error"
      elevation="2"
    >
      {{ error }}
    </v-alert>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import axios from '@/plugins/axios';
  import numbersFormats from '@/mixins/numbersFormats';

  export default {
    name: 'MonthEndTable',
    mixins: [numbersFormats],
    props: {
      chnl: {
        type: String,
        required: true,
      },
      directorCode: {
        type: String,
        default: '',
      },
      isTerritorialDirector: Boolean,
    },
    data: () => ({
      headers: [
        {
          title: 'Dirección',
        },
        { title: 'Cierre semana \n anterior' },
        {
          title: '% de crecimiento \n semana anterior VS \n su semana anterior',
        },
        { title: 'Promedio facturación \n utlimas 12 semanas' },
        { title: 'Facturación de \n PNC semana actual' },
        { title: 'Facturación total \n semana actual' },
        { title: '% de facturación del \n mes VS ppto' },
        { title: '% de pedidos VS \n ppto del mes' },
      ],
      data: [],
      loading: true,
      error: '',
    }),
    computed: {
      colorClass() {
        return this.chnl != 'PR' ? 'dt-border-style' : 'pr-border-style';
      },
      ...mapGetters({ user: 'auth/user' }),
    },
    mounted() {
      this.weeklyBillingSummary();
    },
    methods: {
      async weeklyBillingSummary() {
        try {
          const params = {
            channel: this.chnl,
          };
          if (this.isTerritorialDirector) params.rgManager = this.directorCode;
          const response = await axios.get(
            '/daily-director/weekly-billing-summary-management',
            {
              params: params,
            }
          );
          this.data = response.data;
        } catch (error) {
          this.error = `Error al obtener la consulta ${error}`;
          this.loading = false;
        }
        this.loading = false;
      },
    },
  };
</script>
